import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"],
  _excluded2 = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// packages/react/slot/src/Slot.tsx
import * as React from "react";
import { composeRefs } from "@radix-ui/react-compose-refs";
import { Fragment, jsx } from "react/jsx-runtime";
var Slot = React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    slotProps = _objectWithoutProperties(props, _excluded);
  var childrenArray = React.Children.toArray(children);
  var slottable = childrenArray.find(isSlottable);
  if (slottable) {
    var newElement = slottable.props.children;
    var newChildren = childrenArray.map(function (child) {
      if (child === slottable) {
        if (React.Children.count(newElement) > 1) return React.Children.only(null);
        return React.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /* @__PURE__ */jsx(SlotClone, _objectSpread(_objectSpread({}, slotProps), {}, {
      ref: forwardedRef,
      children: React.isValidElement(newElement) ? React.cloneElement(newElement, void 0, newChildren) : null
    }));
  }
  return /* @__PURE__ */jsx(SlotClone, _objectSpread(_objectSpread({}, slotProps), {}, {
    ref: forwardedRef,
    children: children
  }));
});
Slot.displayName = "Slot";
var SlotClone = React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    slotProps = _objectWithoutProperties(props, _excluded2);
  if (React.isValidElement(children)) {
    var childrenRef = getElementRef(children);
    return React.cloneElement(children, _objectSpread(_objectSpread({}, mergeProps(slotProps, children.props)), {}, {
      // @ts-ignore
      ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
    }));
  }
  return React.Children.count(children) > 1 ? React.Children.only(null) : null;
});
SlotClone.displayName = "SlotClone";
var Slottable = function Slottable(_ref) {
  var children = _ref.children;
  return /* @__PURE__ */jsx(Fragment, {
    children: children
  });
};
function isSlottable(child) {
  return React.isValidElement(child) && child.type === Slottable;
}
function mergeProps(slotProps, childProps) {
  var overrideProps = _objectSpread({}, childProps);
  var _loop = function _loop() {
    var slotPropValue = slotProps[propName];
    var childPropValue = childProps[propName];
    var isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = function () {
          childPropValue.apply(void 0, arguments);
          slotPropValue.apply(void 0, arguments);
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = _objectSpread(_objectSpread({}, slotPropValue), childPropValue);
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  };
  for (var propName in childProps) {
    _loop();
  }
  return _objectSpread(_objectSpread({}, slotProps), overrideProps);
}
function getElementRef(element) {
  var _Object$getOwnPropert, _Object$getOwnPropert2;
  var getter = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.get;
  var mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_Object$getOwnPropert2 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object$getOwnPropert2 === void 0 ? void 0 : _Object$getOwnPropert2.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var Root = Slot;
export { Root, Slot, Slottable };